import SettingsSwitch from './SettingsSwitch'
export { SettingsSwitch }
